import addModal from './addModal.vue';
import { countryList } from '../request';
export default {
  components: {
    addModal
  },
  data() {
    return {
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        page: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      form: {
        name: ''
      },
      addVisible: false,
      isEdit: false,
      tableData: [{
        id: 1
      }],
      columns: [{
        slots: {
          title: '国家名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '货币'
        },
        dataIndex: 'currencyName',
        key: 'currencyName',
        align: 'center'
      }, {
        slots: {
          title: '语言'
        },
        dataIndex: 'language',
        key: 'language',
        align: 'center'
      }, {
        slots: {
          title: '日期格式'
        },
        dataIndex: 'dateFormat',
        key: 'dateFormat',
        width: 160,
        align: 'center'
      }, {
        slots: {
          title: '时值'
        },
        dataIndex: 'chronaxie',
        key: 'chronaxie',
        width: 160,
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      }]
    };
  },
  created() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.pagination.current = 1;
      this.getListData();
      this.i18nCurrencyUnit();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await countryList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
    },
    openAddModal(value) {
      this.isEdit = value;
      this.addVisible = true;
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    },
    reset() {
      this.form = {
        language: 'zh'
      };
    }
  }
};